module.exports = __webpack_public_path__ + "img/Romania GP2.4eee823f.png";